import axios from "axios";

// Send new question to chat assistant
// params: { userId: number, language: string }
const post = ({ userId, language }) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/ai/user_api/v1/get_chat_assistant_history", {
        user_id: userId,
        language: language,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data ?? error));
  });
};

const getChatAssistantHistory = {
  post,
};

export default getChatAssistantHistory;
